import { render, staticRenderFns } from "./RegistrarAdmin.vue?vue&type=template&id=4dfae66a&scoped=true"
import script from "./RegistrarAdmin.vue?vue&type=script&lang=js"
export * from "./RegistrarAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfae66a",
  null
  
)

export default component.exports